import { configureStore, combineReducers, Tuple } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import createSagaMiddleware from "@redux-saga/core";
import type { TypedUseSelectorHook } from "react-redux";
import { useDispatch } from "react-redux";
import logger from "redux-logger";

import rootSaga from "./rootSaga";

const sagaMiddleware = createSagaMiddleware();

const appInfoReducer = (state = {}) => state;

const rootReducer = combineReducers({
  appInfo: appInfoReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    let middleware: Tuple<any> = getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    });
    middleware = middleware.concat(sagaMiddleware);

    if (process.env.NODE_ENV === "development") {
      middleware = middleware.concat(logger);
    }

    return middleware;
  },
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
